import { css } from '@adornis/chemistry/directives/css.js';
import { type XFlex } from '@adornis/chemistry/elements/components/x-flex.js';
import { XTooltip } from '@adornis/popover/x-tooltip.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { followCursor, type Props } from 'tippy.js';
/**
 * @element tr-tooltip
 */
@customElement('tr-tooltip')
export class TrTooltip extends XTooltip {
  @property({ attribute: 'placement' }) placement: 'top' | 'bottom' = 'top';

  protected override _defaultOptions() {
    return {
      content: this.content,
      placement: this.placement,
      interactive: false,
      trigger: 'mouseenter focus',
      triggerTarget: this.parentElement,
      appendTo: window.document.body,
      animation: 'none',
      arrow: true,
      maxWidth: 'none',
      touch: false,
      hideOnClick: true,
      theme: 'custom',
      duration: [0, 0],
      delay: [0, 0],
      followCursor: false,
      plugins: [followCursor],
      zIndex: 1003,
    } as Partial<Props>;
  }

  override render() {
    return html`
      <tr-flex
        padding="sm"
        ${css({
          background: this.colors.tone.tooltipBackground,
          color: this.colors.white,
          borderRadius: this.sizes.borderRadius,
          fontFamily: this.fontFamily,
          padding: `${this.spacing.sm} ${this.spacing.md}`,
          maxWidth: '300px',
          fontSize: '1rem',
        })}
      >
        <tr-text ${ref(content => (this._contentFlex = content as XFlex | undefined))}> </tr-text>
      </tr-flex>
    `;
  }

  override styles = () => [...super.styles()];
}
